import { alpha } from '@mui/material/styles';

import { HIGHLIGHT_COLORS, SOLUTION_TOOL_PREFIX } from 'my-core/editor-utils';
import { palette } from 'my-theme/myTheme';

export const TEXT_COLORS = [
  { style: 'COLOR_ACCENT_1', color: palette.green.main, old: true },
  { style: 'COLOR_ACCENT_2', color: palette.orange.main, old: true },
  { style: 'COLOR_ACCENT_3', color: palette.secondary.main, old: true },

  { style: 'COLOR_PRIMARY_DARK', color: palette.primary.main, old: true },
  { style: 'COLOR_PURPLE_DARK', color: palette.purple.main, old: true },
  { style: 'COLOR_CYAN_DARK', color: palette.cyan.main, old: true },
  { style: 'COLOR_GREEN_DARK', color: palette.green.main, old: true },
  { style: 'COLOR_YELLOW_DARK', color: palette.yellow.main, old: true },
  { style: 'COLOR_ORANGE_DARK', color: palette.orange.main, old: true },
  { style: 'COLOR_SECONDARY_DARK', color: palette.secondary.main, old: true },

  { style: 'COLOR_GREY', color: palette.text.secondary, label: 'grey', hotkey: 'g' }, // '#757575'
  { style: 'COLOR_PRIMARY', color: palette.primary.main, label: 'blue', hotkey: 'h' },
  { style: 'COLOR_ORANGE', color: '#FF6700', label: 'orange', hotkey: 'j' }, // palette.orange.main
  { style: 'COLOR_GREEN', color: palette.green.main, label: 'green', hotkey: 'k' },
  { style: 'COLOR_PURPLE', color: palette.purple.main, label: 'purple', hotkey: 'l' },
  { style: 'COLOR_CYAN', color: palette.cyan.main, old: true },
  { style: 'COLOR_YELLOW', color: palette.yellow.main, old: true },
  { style: 'COLOR_SECONDARY', color: palette.secondary.main, old: true },
];

const HIGHLIGHT_OPACITY = 0.5;
const SOLUTION_HIGHLIGHT_OPACITY = 0.8;

// Deliberately not one of the HIGHLIGHT_COLORS, so overlaps can't be confused with a highlight
// the student or the author drew themselves.
export const HIGHLIGHT_OVERLAP_COLOR = alpha(palette.green.main, HIGHLIGHT_OPACITY);

const highlightStyles = Object.fromEntries(
  HIGHLIGHT_COLORS.flatMap(color => [
    [`HIGHLIGHT_${color.toUpperCase()}`, { backgroundColor: alpha(palette[color].main, HIGHLIGHT_OPACITY) }],
    [
      `HIGHLIGHT_${SOLUTION_TOOL_PREFIX.toUpperCase()}${color.toUpperCase()}`,
      { backgroundColor: alpha(palette[color].main, SOLUTION_HIGHLIGHT_OPACITY) },
    ],
  ]),
);

export const defaultStyleMap = TEXT_COLORS.reduce(
  (mem, { color, style }) => {
    mem[style] = { color };
    return mem;
  },
  {
    SUP: {
      verticalAlign: 'super',
      fontSize: 'smaller',
    },
    SUB: {
      verticalAlign: 'sub',
      fontSize: 'smaller',
    },
    ...highlightStyles,
    LINE_THROUGH: {
      textDecoration: 'line-through',
    },
    // Marks text highlighted by both the student and the solution. Only wins over the other
    // fills when it is the last style applied to the character.
    HIGHLIGHT_OVERLAP: {
      backgroundColor: HIGHLIGHT_OVERLAP_COLOR,
    },
  },
);
